import jwt_decode from "jwt-decode";
import { createContext, Dispatch, ReactNode, SetStateAction, useState } from "react";
import useLocalStorage from "../hook/useLocalStorage";
import { getCurrentBrowser } from "../libs/currentBrowser";

interface AuthProviderProps {
  children: ReactNode;
}

interface AuthContextProps {
  token: any;
  setToken: any;
  removeToken: any;
  profileId: number;
  userName: string;
  userId: number;
  contractType: string;
  corporation: string;
  corporationId: number;
  accessIds: number[];
  currentBrowser: string;
  corporationCreatedBy: number;
  statusCorporation: {
    daysToUse: number;
    daysUsed: number;
    plan: string;
    planOk: boolean;
  };
  logindata: { email: string; password: string };
  setLoginData: Dispatch<SetStateAction<{ email: string; password: string }>>;
}

export const AuthContext = createContext({} as AuthContextProps);

export function AuthProvider({ children }: AuthProviderProps) {
  const [token, setToken, removeToken] = useLocalStorage("token");
  const [logindata, setLoginData] = useState({ email: "", password: "" });

  const decode: any = token && jwt_decode(token as string);

  const userId = decode?.userId;
  const userName = decode?.name;
  const profileId = decode?.profileId;
  const contractType = decode?.contractType;
  const corporation = decode?.corporationName || "Tegra";
  const corporationId = decode?.corporationId;
  const accessIds = decode?.accessIds;
  const corporationCreatedBy = decode?.corporationCreatedBy;
  const statusCorporation = decode?.statusCorporation;
  const currentBrowser = getCurrentBrowser();

  return (
    <AuthContext.Provider
      value={{
        token,
        setToken,
        removeToken,
        profileId,
        userName,
        userId,
        contractType,
        corporation,
        corporationId,
        accessIds,
        currentBrowser,
        corporationCreatedBy,
        statusCorporation,
        logindata,
        setLoginData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
